import hdrm from '../../hdrm';
import actions from '../actions';
import blockTemplates from '../../block-templates';
import siteDependencies from '../../site-dependencies';
import hooks from '../../hooks';
// dev-components-import-token

const loadPage = (dispatch, page) => {
  hooks.handlers.onBeforePageLoaded(page);
  dispatch(actions.setLoadedStatus(false));
  const liveDocument = hdrm.initWith(page.html);

  siteDependencies.injections.withSiteDependencies(liveDocument);
  hdrm.injections.withIFrameAdditives(liveDocument);
  blockTemplates.injections.withBlockTemplatesDependencies(liveDocument, page.id);

  // dev-components-inject-content-token

  const mappedHTML = hdrm.accessors.getMappedHTML();
  const action = actions.connectMappedHTML(mappedHTML);

  dispatch(action);
};

export default loadPage;
